export default __webpack_public_path__ + "static/media/icons-gpa-3.94d778ca.png";